import { getTimezoneConfig, updateTimezoneConfig } from "@/services/timezones";
import React, { useEffect, useState } from "react";


const TimezoneConfig: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await getTimezoneConfig();
    setRows(res || []);
    setInitial(JSON.stringify(res || []));
  };

  const updateField = (index: number, key: string, value: number) => {
    const updated = [...rows];
    updated[index][key] = value;
    setRows(updated);
  };

  const hasChanges =
    initial !== "" && JSON.stringify(rows) !== initial;

  const handleSave = async () => {
    setSaving(true);
    await updateTimezoneConfig({ items: rows });
    setInitial(JSON.stringify(rows));
    setSaving(false);
  };

  const handleCancel = () => {
    setRows(JSON.parse(initial));
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">
        <div className="text-sm text-gray-800 font-medium">
          Configure Office Hours
        </div>
<div className="space-y-1">

  {rows.map((r, index) => (
    <div
      key={r.Id}
      className="flex items-center justify-between px-3 py-1.5 border border-gray-200 rounded-md bg-white"
    >
      <span className="text-xs text-gray-800">
        {r.DisplayName}
      </span>

      <div className="flex items-center">
        <input
          type="number"
          className="w-50 border border-gray-300 px-3 py-1 rounded text-xs
                     focus:outline-none focus:ring-2 focus:ring-orange-400"
          value={r.OfficeStartHour}
          onChange={(e) =>
            updateField(index, "OfficeStartHour", Number(e.target.value))
          }
        />

        <span className="mx-2 text-xs text-gray-500">to</span>

        <input
          type="number"
          className="w-50 border border-gray-300 px-3 py-1 rounded text-xs
                     focus:outline-none focus:ring-2 focus:ring-orange-400"
          value={r.OfficeEndHour}
          onChange={(e) =>
            updateField(index, "OfficeEndHour", Number(e.target.value))
          }
        />
      </div>
    </div>
  ))}

</div>





      <div className="flex justify-end items-center gap-2">

        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 rounded text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-orange-500 text-white px-3 py-1 rounded text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>

      </div>

    </div>
  );
};

export default TimezoneConfig;
